<template>
  <a-modal
    title="趋势指标"
    :width="width"
    :visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel">
    <a-tabs
      v-model="selectedKey"
      tab-position="left"
      @change="tabChangeHandle"
    >
      <a-tab-pane v-for="(item,index) in dataList" :key="index" :tab="item.name" >
        <div style="min-height: 300px">
          <line-chart-multid :dataSource="line.data" :fields="line.fields"  :aliases="line.aliases"></line-chart-multid>
          <a-table
            ref="table"
            size="middle"

            rowKey="name"
            :columns="columns"
            :dataSource="item.list"
            :pagination="false"
            :loading="loading"
          >

          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
  import LineChartMultid from '@/components/chart/LineChartMultid'
  import { getAction } from '@/api/manage'
  export default {
    name: 'TrendModal',
    components: { LineChartMultid },
    props:{
      id:{
        type:String,
        default:''
      },
      width:{
        type:String,
        default:'60%'
      }
    },
    data(){
      return {
        loading:false,
        visible:false,
        selectedKey:'',
        line:{
          data:[
            // { type: 'V/0基线 2022-07-01', value: null},
            // { type: '2022-07-02', value: 7.1},
            // { type: '2022-07-03', value: 7.2},
            // { type: '2022-07-04', value: 6.0},
          ],
          fields:['value'],
          aliases:[
            {field:'value',alias:'趋势'},
          ],
        },
        columns:[
          { title: '记录周期', align: 'center', width: 200, dataIndex: 'name' },
          { title: '记录日期', align: 'center', width: 200, dataIndex: 'submit_time' },
          { title: '数值', align: 'center', width: 200, dataIndex: 'value' },
        ],
        dataList:[]
      }
    },
    mounted(){
      this.loadData()
    },
    watch:{
      id(){
        this.loadData()
      }
    },
    methods:{
      loadData(){
        if(this.id){
          getAction('/patient/patient/getTrendIndicator',{id:this.id}).then(res=>{
            if(res.success){
              const dataList = {}
              res.result.forEach(item=>{
                const data = dataList[item.id] || {
                  name:item.ternd_name
                }
                data.list = data.list || []
                data.list.push(item)
                dataList[item.id] = data
                this.dataList = dataList
                if(!this.selectedKey){
                  this.selectedKey = item.id
                }
              })
              if(this.selectedKey){
                this.tabChangeHandle()
              }
            }
          })
        }
      },
      tabChangeHandle(){
        let data = this.dataList[this.selectedKey]
        if(!data){
          return
        }
        const lineData = []
        let error = false
        data.list.forEach(item=>{
          if(error){
            return
          }
          if(item.value!=null && item.value!='' && item.value!=undefined &&isNaN(item.value)){
            error = true
          }
          lineData.push(
            { type: `${item.name} ${item.submit_time}`, value: item.value!=null && item.value!='' && item.value!=undefined? parseFloat(item.value):null},
          )
        })
        if(!error){
          this.$set(this.line,'data',lineData)
        }
      },
      view(){
        this.visible = true
      },
      handleSubmit(){
        this.handleCancel()
      },
      handleCancel(){
        this.visible = false
      },
    }
  }
</script>

<style scoped>

</style>